import { createFileRoute } from '@tanstack/react-router';
import { AttendanceRulePolicyPage } from './-components/AttendanceRulePolicyPage';
export const Route = createFileRoute('/_staff/attendances/_layout/rule-and-policy/')({
  component: AttendanceRulePolicyPage
});